<template>
  <div class="page-container">
    <div class="main">
      <page :url="url" :form="form" @reset="reset" ref="pageRef">
        <template slot="tableSearch">
          <el-form-item :label="$t('text.date')">
            <el-select v-model="form.date" style="width: 100px">
              <el-option v-for="date in daysSevenAgoRange"
                         :key="date.value"
                         :label="date.label"
                         :value="date.value"/>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.upstream')">
            <el-select v-model="form.upstream" :placeholder="$t('message.chooseOne')">
              <el-option v-for="item in upstreamList"
                         :key="item.code"
                         :label="item.displayName"
                         :value="item.code"/>
            </el-select>
          </el-form-item>
        </template>

        <template slot="buttonArea">
          <el-button type="primary" size="small" style="float: right" @click="handleEditPackageAmount">{{
              $t('text.editPackageAmount')
            }}
          </el-button>
        </template>

        <template slot="tableColumn">
          <el-table-column :label="$t('text.serialNumber')"
                           align="center">
            <template slot-scope="scope">
              {{ listLength - scope.$index }}
            </template>
          </el-table-column>
          <el-table-column prop="hasCallback"
                           :label="$t('text.calledBack')"
                           align="center">
            <template slot-scope="scope">
              <i class="el-icon-success successIcon" v-if=scope.row.hasCallback></i>
              <i class="el-icon-circle-close dangerIcon" v-else></i>
            </template>
          </el-table-column>
          <el-table-column prop="upstream"
                           :label="$t('text.upstream')"
                           align="center"/>
          <el-table-column prop="firstCreatedDateTime"
                           :label="$t('text.creationTimeOfFirstOrder')"
                           :formatter="$formatter.formatDate"
                           align="center"/>
          <el-table-column prop="lastCreatedDateTime"
                           :label="$t('text.creationTimeOfLastOrder')"
                           :formatter="$formatter.formatDate"
                           align="center"/>
          <el-table-column prop="lastCreatedOrderId"
                           :label="$t('text.lastOrderId')"
                           align="center"/>
          <el-table-column prop="isDownloaded"
                           :label="$t('text.downloaded')"
                           align="center">
            <template slot-scope="scope">
              <i class="el-icon-success successIcon" v-if=scope.row.isDownloaded></i>
              <i class="el-icon-circle-close dangerIcon" v-else></i>
            </template>
          </el-table-column>
          <el-table-column :label="$t('text.bankName')"
                           align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.bankCode" :placeholder="$t('message.chooseOne')">
                <el-option v-for="item in bankList"
                           :key="item.code"
                           :label="item.name"
                           :value="item.code"/>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column fixed="right"
                           :label="$t('text.actions')"
                           :width="100"
                           align="center">
            <template slot-scope="scope">
              <el-button :class="getButtonClass(scope.row)" size="mini" @click="handleDownload(scope.row)">
                {{ $t('text.download') }}
              </el-button>
            </template>
          </el-table-column>
        </template>
      </page>
      <PackageAmountEdit :show.sync="show"/>
    </div>
  </div>
</template>

<script>
import Page from "@/components/Page.vue";
import moment from "moment";
import PackageAmountEdit from "@/views/order/components/PackageAmountEdit.vue";

export default {
  name: "OrderPaymentDownload",
  components: {
    PackageAmountEdit,
    page: Page
  },
  data() {
    return {
      url: "/order/orderPayment/packageList",
      form: {
        date: "",
        upstream: null,
        bank: null
      },
      upstreamList: [],
      bankList: [],
      downloadButtonDisabled: {},
      show: false
    };
  },
  computed: {
    daysSevenAgoRange() {
      // 取得當前日期
      const startDate = moment();

      // 建立日期區間為七天
      const dateRange = [];

      for (let i = 0; i < 7; i++) {
        const date = startDate.clone().subtract(i, "days");
        dateRange.push({
          label: date.format("MM/DD"),
          value: date.format("YYYYMMDD")
        });
      }

      return dateRange;
    },
    listLength() {
      return this.$refs.pageRef.list.length;
    }
  },
  methods: {
    reset() {
      this.form.date = this.daysSevenAgoRange[0].value;
    },
    handleDownload(row) {
      if (row.bankCode === undefined) {
        this.$message({
          message: this.$t("message.selectBankName"),
          type: "error"
        });
        return;
      }

      const fileName = row.fileName.replace(".xlsx", "");
      this.$axios
          .get("/order/orderPayment/packaged/" + fileName, {
            params: {bankCode: row.bankCode},
            responseType: "blob"
          })
          .then((res) => {
            if (res.data) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              const contentDisposition = res.headers["content-disposition"];
              const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              const matches = filenameRegex.exec(contentDisposition);
              let filename = "";
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
              link.setAttribute("download", filename);
              document.body.appendChild(link);
              link.click();
            } else if (res.text) {
              res.text()
                  .then(JSON.parse)
                  .then((res) => {
                    if (res.code !== 200) {
                      this.$message({
                        message: res.msg,
                        type: "error"
                      });
                    } else {
                      this.$message({
                        message: res.msg,
                        type: "success"
                      });
                    }
                  });
            }
          });
    },
    handleEditPackageAmount() {
      this.show = true;
    },
    getButtonClass(row) {
      const selectedUpstream = this.upstreamList.find(
          (item) => item.code === row.upstream
      );
      if (!selectedUpstream) {
        return "primary";
      }

      return selectedUpstream.code === this.upstreamList[0].code
      ? "payButton"
          :"gameButton";
    }
  },
  mounted() {
    this.reset();
  },
  created() {
    this.reset();

    this.$axios
        .get("/order/orderPayment/selectPackagedUpstream", {params: {}})
        .then((res) => {
          this.upstreamList = res.data;
        });

    this.$axios
        .get("/order/orderPayment/selectPackagedPaymentBank", {params: {}})
        .then((res) => {
          this.bankList = res.data;
        });
  }
};
</script>

<style scoped>
.successIcon {
  color: #67C23A;
  font-size: 24px;
}

.dangerIcon {
  color: #F56C6C;
  font-size: 24px;
}

.payButton {
  background-color: #F56C6C;
  color: white;
}

.gameButton {
  background-color: #6550ca;
  color: white;
}
</style>
